import { observable, makeObservable, action } from 'mobx';
import { State, TabName, setTab } from './Types';
import { LearningDesignResource } from '../../../../../../../../../../Types';

class Store {
  @observable
  state: State;
  readonly resource: LearningDesignResource;

  constructor(tab: TabName, resource: LearningDesignResource) {
    makeObservable(this);
    this.state = setTab(tab);
    this.resource = resource;
  }

  @action
  updateTab = (tab: TabName) => {
    this.state = setTab(tab);
  };
}

export default Store;
